module.exports = __webpack_public_path__ + "static/media/activity-icon-commit-vote.d43bfc0c.svg";